import { NotificationBadgeModel } from 'api-hooks/notification/model';
import { SalePurchaseTabEnum } from 'api-hooks/sale/common';
import { TourStatusEnum } from 'common/constants/enum';
import Separator from 'components/common/separator';
import Tabs from 'components/common/tabs';
import { NotificationBadge } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  setActiveKey: (value: React.SetStateAction<React.Key>) => void;
  activeKey: React.Key;
  setStatus: (value: React.SetStateAction<string | undefined>) => void;
  badge?: { [key: string]: NotificationBadgeModel };
}

export function useTourTabStatus() {
  const activeStatus = [TourStatusEnum.Active].join('|');
  const needApprovalStatus = [
    TourStatusEnum.Draft,
    TourStatusEnum.PendingApproval,
    TourStatusEnum.CancelDraft,
    TourStatusEnum.PendingCancelApproval,
    TourStatusEnum.CloseDraft,
    TourStatusEnum.PendingCloseApproval,
    TourStatusEnum.RevertCloseDraft,
    TourStatusEnum.PendingRevertCloseApproval,
  ].join('|');

  const completeStatus = [TourStatusEnum.Closed, TourStatusEnum.Canceled].join(
    '|',
  );
  const allStatus = [activeStatus, needApprovalStatus, completeStatus].join(
    '|',
  );
  const tabStatus = {
    '0': allStatus,
    '1': activeStatus,
    '2': needApprovalStatus,
    '3': completeStatus,
  };

  return {
    activeStatus,
    needApprovalStatus,
    completeStatus,
    allStatus,
    tabStatus,
  };
}

export default function TourListTabs(props: Props) {
  const { t } = useTranslation();

  const { activeKey, setActiveKey, setStatus, badge } = props;

  const { tabStatus } = useTourTabStatus();
  return (
    <Tabs
      activeKey={activeKey}
      onChangeActive={({ activeKey }) => {
        setActiveKey(activeKey);
        setStatus(tabStatus[activeKey]);
      }}
      items={[
        { title: t('common:all'), component: <></> },
        {
          title: (
            <>
              {t('common:processed')}
              {!!badge?.[SalePurchaseTabEnum.Processed] &&
                !!badge?.[SalePurchaseTabEnum.Processed].count && (
                  <>
                    <Separator gap={8} />
                    <NotificationBadge
                      style={{
                        backgroundColor:
                          badge?.[SalePurchaseTabEnum.Processed]
                            .background_color,
                        color: badge?.[SalePurchaseTabEnum.Processed].color,
                      }}
                    >
                      {badge?.[SalePurchaseTabEnum.Processed].count}
                    </NotificationBadge>
                  </>
                )}
            </>
          ),
          component: <></>,
        },
        {
          title: (
            <>
              {t('common:need_approval')}
              {!!badge?.[SalePurchaseTabEnum.NeedApproval] &&
                !!badge?.[SalePurchaseTabEnum.NeedApproval].count && (
                  <>
                    <Separator gap={8} />
                    <NotificationBadge
                      style={{
                        backgroundColor:
                          badge?.[SalePurchaseTabEnum.NeedApproval]
                            .background_color,
                        color: badge?.[SalePurchaseTabEnum.NeedApproval].color,
                      }}
                    >
                      {badge?.[SalePurchaseTabEnum.NeedApproval].count}
                    </NotificationBadge>
                  </>
                )}
            </>
          ),
          component: <></>,
        },
        { title: t('common:complete'), component: <></> },
      ]}
      overrideStyles={{
        tabList: { minHeight: '0px' },
        tab: { minHeight: '0px', height: '0', flexGrow: '0' },
        tabPanel: { minHeight: '0px', height: '0', flexGrow: '0' },
      }}
    />
  );
}
